//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import QuestionaryCard from '~/components/Questionaries/dashboard/QuestionaryCard.vue'
import { SECTIONS } from '~/constants/questionary'
import { showErrorNotification } from '~/util/notifications'
import SectionCardsHeader from '~/components/Dashboard/Employee/SectionCardsHeader.vue'
import SectionCards from '~/components/Dashboard/Employee/SectionCards.vue'
import AddSkillsCard from '~/components/Dashboard/Employee/Collaborator/AddSkillsCard.vue'
import InventorySkillCard from '~/components/Dashboard/Employee/Collaborator/InventorySkillCard.vue'
import ProjectQuestionariesContainer from '~/components/Dashboard/Employee/Collaborator/ProjectQuestionariesContainer.vue'
export default {
  components: {
    QuestionaryCard,
    SectionCardsHeader,
    SectionCards,
    AddSkillsCard,
    InventorySkillCard,
    ProjectQuestionariesContainer,
  },
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
    permissions: {
      type: Object,
      default: () => ({}),
    },
    projects: {
      type: Array,
      default: () => [],
    },
  },
  async fetch() {
    this.$store.commit('loading', true)
    try {
      this.questionaries = await this.getQuestionaries()
      this.modelQuestionaries = await this.getModelQuestionaries()
    } catch (error) {
      showErrorNotification(this, 'Ocurrió un error')
    } finally {
      this.$store.commit('loading', false)
    }
  },
  data() {
    return {
      activeQuestionary: null,
      isEnabledInventorySkills: false,
      questionaries: [],
      modelQuestionaries: [],
    }
  },
  computed: {
    userId() {
      return this.$strapi.user.id
    },
    projectId() {
      if (!this.$strapi.user.project) {
        return null
      }
      return this.$strapi.user.project.id || this.$strapi.user.project
    },
    showBasicCards() {
      if (
        this.questionaries.length === 0 &&
        this.modelQuestionaries.length === 0
      ) {
        return true
      }
      return (
        this.questionaries.every((questionary) => questionary.is_finish) &&
        this.modelQuestionaries.every((questionary) => questionary.is_finish)
      )
    },
    hasActiveQuestionaries() {
      return this.projects.some(
        ({ project }) => !!project.main_target_occupation_id
      )
    },
    hasModelQuestionaries() {
      return this.projects.some((project) => project.has_models)
    },
    projectsWithQuestionaries() {
      return this.projects.map((project) => ({
        ...project,
        questionary: this.questionaries.find(
          (q) => q.project.id === project.id
        ),
        modelQuestionary: this.modelQuestionaries.find(
          (mq) => mq.project.id === project.id
        ),
      }))
    },
  },
  methods: {
    statusQuestionary(questionary) {
      if (!questionary?.id) {
        return 'in-pending'
      }
      if (questionary?.is_finish) {
        return 'in-complete'
      }
      if (questionary?.id) {
        return 'in-progress'
      }
      return ''
    },
    actionLabel(questionary, hasModelQuestionary) {
      if (!questionary?.id) {
        return this.$t('dashboard.employee.questionary.action.isPending')
      }
      if (questionary?.is_finish && hasModelQuestionary) return
      return questionary?.is_finish
        ? this.$t('dashboard.employee.questionary.action.isFinish')
        : this.$t('dashboard.employee.questionary.action.isNotFinish')
    },
    async getQuestionaries() {
      if (
        this.projects.length === 0 ||
        !this.permissions.isEnabledMatchPotential
      ) {
        return []
      }
      try {
        const occupationIds = this.projects.map(
          (project) => project.main_target_occupation_id
        )
        let occupations = []
        if (occupationIds.length > 0) {
          occupations = await this.$repository.occupation.findAll({
            _where: {
              id_in: occupationIds,
            },
            _limit: -1,
          })
        }
        const activeQuestionaries = await this.$repository.questionary.getQuestionariesByUserInActiveProjects()
        const questionaries = []
        for (const project of this.projects) {
          const questionariesForProject = activeQuestionaries
            .filter((q) => q.project === project.id)
            .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
          const questionary = questionariesForProject[0] || {}
          questionary.project = project
          const targetOccupation = project.main_target_occupation_id
            ? occupations.find(
                (occ) => occ.id === project.main_target_occupation_id
              )
            : null

          if (targetOccupation) {
            questionary.targetOccupation = {
              id: targetOccupation.id,
              title: targetOccupation.title,
            }
          }

          if (questionary?.is_finish) {
            questionary.match = await this.getMatch(targetOccupation.id)
          }
          questionaries.push(questionary)
        }
        return questionaries
      } catch (error) {
        showErrorNotification(
          this,
          'Ocurrió un error al obtener el cuestionario'
        )
      }
    },
    async getModelQuestionaries() {
      if (
        this.projects.length === 0 ||
        !this.permissions.isEnabledKitOfSkills
      ) {
        return []
      }
      try {
        const activeModelQuestionaries = await this.$repository.modelQuestionary.findModelQuestionariesInActiveProjects()

        const modelQuestionaries = []
        for (const project of this.projects) {
          if (!project.has_models) {
            continue
          }
          const questionaries = activeModelQuestionaries
            .filter((q) => q.project === project.id)
            .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
          const questionary = questionaries[0] || {}
          questionary.project = project

          modelQuestionaries.push(questionary)
        }

        return modelQuestionaries
      } catch (error) {
        showErrorNotification(
          this,
          'Ocurrió un error al obtener los cuestionarios modelo'
        )
      }
    },
    async handleClickModelQuestionary(modelQuestionary) {
      let questionary = null
      if (!modelQuestionary?.id) {
        questionary = await this.createModelQuestionary(
          modelQuestionary.project.id
        )
        if (!questionary.code) {
          showErrorNotification(
            this,
            'Hubo un problema al crear el cuestionario'
          )
        }
      } else {
        questionary = modelQuestionary
      }
      this.$router.push(`/mis-cuestionarios/nuevo?code=${questionary.code}`)
    },
    async handleClickQuestionary(questionary) {
      if (!questionary?.id) {
        const newQuestionary = await this.createQuestionary(
          questionary.project.id,
          questionary.targetOccupation.id
        )
        if (newQuestionary?.code) {
          this.$router.push(
            `/cuestionarios/instrucciones?code=${newQuestionary.code}`
          )
          return
        }
      }

      if (!questionary?.is_finish) {
        const routes = {
          [SECTIONS.INSTRUCTIONS]: `/cuestionarios/instrucciones?code=${questionary.code}`,
          [SECTIONS.ORIGIN_SELECT]: `/cuestionarios/origen?code=${questionary.code}`,
          [SECTIONS.ORIGIN]: `/cuestionarios/habilidades?code=${questionary.code}`,
          [SECTIONS.TARGET]: `/cuestionarios/habilidades?code=${questionary.code}`,
        }
        this.$router.push(routes[questionary.section])
        return
      }
      this.$router.push(`/oportunidades/${questionary.targetOccupation.id}`)
    },
    async createQuestionary(projectId, occupationId) {
      try {
        this.$store.commit('loading', true)
        const questionary = await this.$repository.questionary.save({
          user: this.userId,
          project: projectId,
          occupation: occupationId,
          section: SECTIONS.INSTRUCTIONS,
          is_finish: false,
        })
        return questionary
      } catch (error) {
        showErrorNotification(this, 'Ocurrió un error')
      } finally {
        this.$store.commit('loading', false)
      }
    },
    async createModelQuestionary(projectId) {
      try {
        this.$store.commit('loading', true)
        const questionary = await this.$repository.modelQuestionary.save({
          user: this.userId,
          project: projectId,
          section: SECTIONS.INSTRUCTIONS,
          page: 1,
          total_pages: 1,
          is_finish: false,
        })
        return questionary
      } catch (error) {
        showErrorNotification(this, 'Ocurrió un error')
      } finally {
        this.$store.commit('loading', false)
      }
    },
    async getMatch(occupationId) {
      try {
        const { match } = await this.$repository.user.getMatchWithOccupation({
          occupationId,
        })
        return match
      } catch (error) {
        showErrorNotification(this, 'Ocurrió un error al obtener el match')
        return null
      }
    },
  },
}
